module.exports = __webpack_public_path__ + "static/media/温馨上达.c463ac8b.jpg";